module.exports = __webpack_public_path__ + "img/34.0e9525c8.jpg";